export const Constants = {
  title: 'Entrar',
  subtitle: 'Use suas credenciais para acessar a plataforma.',
  emailLabel: 'E-mail',
  emailPlaceholder: 'nome@empresa.com.br',
  passwordLabel: 'Senha',
  passwordPlaceholder: '••••••••',
  showPassword: 'mostrar senha',
  hidePassword: 'ocultar senha',
  submit: 'Entrar',
  forgotPassword: 'Esqueci a senha',
  footer: 'Acesso restrito a usuários autorizados',
  click: 'Clique aqui',
  sessionExpired: 'Sua sessão expirou. Entre novamente.',
};
